/* eslint-disable */
import React, { useState, useMemo } from "react";
import { Table, Modal, Image } from 'react-bootstrap';
import TableHead from "./TableHead";
import TableBody from "./TableBody";
import OrderStatusModel from "../OrderStatusModel";
import CommonPagination from "../CommonPagination";
import CommonLoader from "../CommonLoader";
import CommonewModel from "../CommonewModel";
import CommonScrollBar from "../CommonScrollBar";
import DeleteModal from "../DeleteModal";
import OrderDetailsViewer from "../OrderDetailsViewer";
import AfsOrderDetailsViewer from "../AfsOrderDetailsViewer";
import CommonRemarkAttachment from "../CommonRemarkAttachment";
import { getStringOfErrorValues } from "../TimeSense";
import ExelIcon from "../../../assets/img/XLS_icon.svg";
import ExportToCSV from "../../Common/ExportToCSV";
import moment from "moment";

const CommonTable = (props) => {
    const { isTableAllow, style, srNumber, tabName, isActionColumnAvailable, isActionTwoColumnAvailable, TableColumns, OrderList, Pagination, EditAccess, PaginationCurrentPage, PaginationFunction, APIcalling, isCollapsable, isTotalAndGrand, isOdiFilterRowColorsAllow, isPodFilterRowColorsAllow, isActionPreviewAvailable, isSelectOrder, setSelectedIds, selectedIds } = props;
    const [ Loader, setLoader ] = useState(false);
    const [ OrderNewModel, setOrderNewModel ] = useState({
        open: false,
        title: "",
        modalType: "",
        Data: {}
    });
    const [showModalNew, setShowModalNew] = useState({
        open: false,
        title: "",
        subtitle: "",
        modalType: "",
        button: "",
        Data: {},
    });
    const [ deleteCommonStateModal, setdeleteCommonStateModal ] = useState({
        title: "",
        description: "",
        open: false,
        delete_id: "",
        delete_url: "",
        date: {},
    });
    const [ OrderViewerModal, setOrderViewerModal ] = useState({
        open: false,
        Title: "Order Details",
        Data: {}
    });
    const [ AfsOrderViewerModal, setAfsOrderViewerModal ] = useState({
        open: false,
        Title: "AFS Order Details",
        Data: {}
    });
    const [ showRemarkAttachment, setShowRemarkAttachment ] = useState({
        open: false,
        title: "",
        Data: {}
    });
    const [ showModal, setShowModal ] = useState({
        open: false,
        title: "",
        modalType: "",
        Reason: "",
        Data: {}
    });
    const [ errorShowModal, setErrorShowModal ] = useState({
        open: false,
        title: "",
        Data: {}
    });
    const [ PreviewErrorModal, setPreviewErrorModal ] = useState({
        open: false,
        Title: "",
        Data: {}
    });

    // MODAL CLOSE FUNCTION
    const onClose = () => {
        setShowRemarkAttachment({
            ...showRemarkAttachment,
            open: false,
            title: "",
            Data: {}
        });
        setShowModal({
            ...showModal,
            open: false,
        });
        setErrorShowModal({
            ...errorShowModal,
            open: false,
            title: "",
            Data: {}
        });
    };

    const responseText = (response1) =>{
        if(response1?.invoice_response === undefined) {
            const response = JSON.parse(response1);
            let text = "";
            if(typeof(response?.errors) == "object"){
                text = text +`</p><b>errors:</b> ${getStringOfErrorValues(response?.errors)}</p>`;
            }
            if(typeof(response?.message) == "object"){
                text = text +`</p><b>message:</b> ${getStringOfErrorValues(response?.message)}</p>`;
            }
            if(typeof(response?.response) == "object"){
                text = text +`</p><b>response:</b> ${getStringOfErrorValues(response?.response)}</p>`;
            }
            if(typeof(response?.message) == "string"){
                text = text +`</p><b>message:</b> ${getStringOfErrorValues(response?.message)}</p>`;
            }
            return text;
        } else {
            const response = JSON.parse(response1?.invoice_response);
            let text = "";
            if(typeof(response?.errors) == "object"){
                text = text +`</p><b>errors:</b> ${getStringOfErrorValues(response?.errors)}</p>`;
            }
            if(typeof(response?.message) == "object"){
                text = text +`</p><b>message:</b> ${getStringOfErrorValues(response?.message)}</p>`;
            }
            if(typeof(response?.response) == "object"){
                text = text +`</p><b>response:</b> ${getStringOfErrorValues(response?.response)}</p>`;
            }
            if(typeof(response?.message) == "string"){
                text = text +`</p><b>message:</b> ${getStringOfErrorValues(response?.message)}</p>`;
            }
            return text;
        };
    };

    // error message modal close
    const CloseErrorMessageModal = () => {
        setPreviewErrorModal({
            ...PreviewErrorModal,
            open: false,
            Title: "",
            Data: {}
        });
    };

    // COMMON DATE FUNCTION
    const CommonDateTimeCommon = (date, url) => {
        if(url === "desktop") {
            if (date !== null) {
                const currentTimezone = moment.tz.guess();
                return moment(date).tz(currentTimezone).format('MMMM Do YYYY, h:mm:ss a');
            } else {
                return "-";
            };
        } else {
            if (date !== null) {
                const currentTimezone = moment.tz.guess();
                return moment(date).tz(currentTimezone).format('MM/DD/YYYY');
            } else {
                return "-";
            };
        };
    };

    return (
      <div
        className="tableView gstreporttableadded"
        style={{ display: isTableAllow ? "block" : "none" }}
      >
        <CommonScrollBar height={style} className={"ScrollbarsSidebar"}>
          <Table
            id={
              tabName === "sales-person-performance"
                ? "salesPersonPerformance"
                : tabName
            }
          >
            <TableHead
              Columns={TableColumns}
              ActionColumn={isActionColumnAvailable}
              isCollapsable={isCollapsable}
              ActionColumnRead={isActionTwoColumnAvailable}
              ActionPreviewState={isActionPreviewAvailable}
              ModalTheading={showModalNew?.subtitle}
              {...(isSelectOrder !== undefined &&
                isSelectOrder !== null &&
                setSelectedIds &&
                selectedIds && {
                  isSelectOrder,
                  selectedIds,
                  setSelectedIds,
                })}
            />
            <TableBody
              isTableAllow={isTableAllow}
              srNumber={srNumber}
              OrderList={OrderList}
              RowData={TableColumns}
              EditAccess={EditAccess}
              Pagination={Pagination}
              OrderNewModel={OrderNewModel}
              setOrderNewModel={setOrderNewModel}
              ActionColumn={isActionColumnAvailable}
              ActionColumnRead={isActionTwoColumnAvailable}
              tabName={tabName}
              setLoader={setLoader}
              showModalNew={showModalNew}
              setShowModalNew={setShowModalNew}
              APIcalling={APIcalling}
              isCollapsable={isCollapsable}
              isTotalAndGrand={isTotalAndGrand}
              deleteCommonStateModal={deleteCommonStateModal}
              setdeleteCommonStateModal={setdeleteCommonStateModal}
              OrderViewerModal={OrderViewerModal}
              setOrderViewerModal={setOrderViewerModal}
              AfsOrderViewerModal={AfsOrderViewerModal}
              setAfsOrderViewerModal={setAfsOrderViewerModal}
              showRemarkAttachment={showRemarkAttachment}
              setShowRemarkAttachment={setShowRemarkAttachment}
              showModal={showModal}
              setShowModal={setShowModal}
              errorShowModal={errorShowModal}
              setErrorShowModal={setErrorShowModal}
              isOdiRowColorsAllow={isOdiFilterRowColorsAllow}
              isPodRowColorsAllow={isPodFilterRowColorsAllow}
              ActionPreviewState={isActionPreviewAvailable}
              PreviewErrorModal={PreviewErrorModal}
              setPreviewErrorModal={setPreviewErrorModal}
              {...(isSelectOrder !== undefined &&
                isSelectOrder !== null &&
                setSelectedIds &&
                selectedIds && {
                  isSelectOrder,
                  selectedIds,
                  setSelectedIds,
                })}
            />
          </Table>
        </CommonScrollBar>

        {/* PAGINATION */}
        {Pagination?.total_records > 10 && (
          <CommonPagination
            currentPage={PaginationCurrentPage}
            paginationLength={Pagination}
            currentFunction={PaginationFunction}
          />
        )}

        {/* ORDER LOG MODAL */}
        {OrderNewModel?.open && (
          <OrderStatusModel
            setOrderNewModel={setOrderNewModel}
            OrderNewModel={OrderNewModel}
          />
        )}

        {/* COMMON MODAL FOR INVOICE CREATIONS */}
        {showModalNew?.open && (
          <CommonewModel
            setShowModalNew={setShowModalNew}
            showModalNew={showModalNew}
            tabName={tabName}
            APIcalling={APIcalling}
          />
        )}

        {/* COMMON LOADER */}
        {Loader && <CommonLoader />}

        {deleteCommonStateModal?.open && (
          <DeleteModal
            deleteCommonStateModal={deleteCommonStateModal}
            setdeleteCommonStateModal={setdeleteCommonStateModal}
          />
        )}

        {OrderViewerModal?.open && (
          <OrderDetailsViewer
            OrderViewerModal={OrderViewerModal}
            APIcalling={APIcalling}
            setOrderViewerModal={setOrderViewerModal}
            EditAccess={EditAccess}
            setLoader={setLoader}
          />
        )}

        {AfsOrderViewerModal?.open && (
          <AfsOrderDetailsViewer
            AfsOrderViewerModal={AfsOrderViewerModal}
            APIcalling={APIcalling}
            setAfsOrderViewerModal={setAfsOrderViewerModal}
            EditAccess={EditAccess}
            setLoader={setLoader}
          />
        )}

        {showRemarkAttachment?.open && (
          <CommonRemarkAttachment
            setShowModalNew={setShowRemarkAttachment}
            showModalNew={showRemarkAttachment}
            onClose={onClose}
          />
        )}

        {errorShowModal?.open && (
          <Modal
            show={errorShowModal?.open}
            className="errorDetailsModal"
            onHide={onClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>{errorShowModal?.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflow: "auto" }}>
              <p
                dangerouslySetInnerHTML={{
                  __html: responseText(errorShowModal?.Data),
                }}
              ></p>
            </Modal.Body>
          </Modal>
        )}

        {PreviewErrorModal?.open && (
          <Modal
            show={PreviewErrorModal?.open}
            className={
              PreviewErrorModal?.Title === "Stock Level Request Data" ||
              PreviewErrorModal?.Title === "Stock Details Request Data"
                ? "errorDetailsModal StockDetailsLogsDetailsModal"
                : "errorDetailsModal"
            }
            onHide={() => CloseErrorMessageModal()}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {PreviewErrorModal?.Title}
                {(PreviewErrorModal?.Title === "Stock Level Request Data" ||
                  PreviewErrorModal?.Title ===
                    "Stock Details Request Data") && (
                  <div className="stock_level_export">
                    <button
                      className="btn exportbtn"
                      id="stocklevelExportbtn"
                      style={{ width: "auto", float: "right" }}
                      onClick={() =>
                        ExportToCSV(
                          PreviewErrorModal?.Title ===
                            "Stock Level Request Data"
                            ? "Stock-Level-Request-List"
                            : "Stock-Details-Request-List",
                        )
                      }
                    >
                      <Image src={ExelIcon} alt="excel" />
                    </button>
                  </div>
                )}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflow: "auto" }}>
              {PreviewErrorModal?.Title === "Stock Level Request Data" ||
              PreviewErrorModal?.Title === "Stock Details Request Data" ? (
                <div className="tableView Check_Serviceable_tableView">
                  {PreviewErrorModal?.Title === "Stock Level Request Data" ? (
                    <Table id="Stock-Level-Request-List">
                      <thead>
                        <tr>
                          <th>Updated On</th>
                          <th>Product Code</th>
                          <th>Product Name</th>
                          <th>Warehouse Code</th>
                          <th>Warehouse</th>
                          <th>Item Code</th>
                          <th>Balance Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {PreviewErrorModal.Data?.request_data?.length > 0 ? (
                          PreviewErrorModal.Data?.request_data?.map(
                            (elm, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {CommonDateTimeCommon(
                                      PreviewErrorModal?.Data?.updated_at,
                                      "desktop",
                                    )}
                                  </td>
                                  <td>{elm?.product_code}</td>
                                  <td>{elm?.product_name}</td>
                                  <td>{elm?.warehouse_code}</td>
                                  <td>{elm?.warehouse}</td>
                                  <td>{elm?.item_code}</td>
                                  <td>{elm?.balance_qty}</td>
                                </tr>
                              );
                            },
                          )
                        ) : (
                          <tr>
                            <td style={{ textAlign: "center" }} colSpan="7">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  ) : (
                    <Table id="Stock-Details-Request-List">
                      <thead>
                        <tr>
                          <th>Updated On</th>
                          <th>Frame Number</th>
                          <th>Warehouse</th>
                          <th>Batch No</th>
                          <th>Item Code</th>
                          <th>Order Code</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {PreviewErrorModal?.Data?.request_data?.length > 0 ? (
                          PreviewErrorModal?.Data?.request_data?.map(
                            (elm, index) => {
                              return (
                                <tr key={index}>
                                  <td>{PreviewErrorModal?.Data?.updated_at}</td>
                                  <td>{elm?.frame_number}</td>
                                  <td>{elm?.warehouse}</td>
                                  <td>{elm?.batch_no}</td>
                                  <td>{elm?.item_code}</td>
                                  <td>{elm?.order_code}</td>
                                  <td>{elm?.status}</td>
                                </tr>
                              );
                            },
                          )
                        ) : (
                          <tr>
                            <td style={{ textAlign: "center" }} colSpan="7">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  )}
                </div>
              ) : (
                <p>
                  {PreviewErrorModal?.Data?.response === undefined
                    ? "No Error Found"
                    : PreviewErrorModal?.Data?.response}
                </p>
              )}
            </Modal.Body>
          </Modal>
        )}
      </div>
    ); 
};

export default CommonTable;